import * as angular from 'angular';

function filterFunction() {
    return function (input: Date) {
        if (input.getHours() === 0 && input.getMinutes() === 0) {
            var date = new Date(input.toString());
            date.setDate(input.getDate() - 1);
            return date;
        }
        return input;
    };
}
angular.module('naut')
    .filter('endDate', filterFunction);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/filters/endDate.filter.ts